import { render, staticRenderFns } from "./QsList.vue?vue&type=template&id=06bd61ee"
import script from "./QsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./QsList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./QsList.vue?vue&type=style&index=0&id=06bd61ee&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports